//import useToken from './useToken';



export class PartidoService {

    getPartidosList(token1) {
        //var respuesta = fetch('http://192.168.1.27/public/laraveldocker/public/api/partidos', {
        var respuesta = fetch(process.env.REACT_APP_URL+'partidos', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer '+token1
            },
            //body: JSON.stringify(credentials)
        })
        .then( function (data) {
            if (data.status != 200){
                console.log("error en respuesta");
                return "Error";
            }
            else{
                console.log("respuesta bien");
                return data.json();
            }
        } );
        return respuesta;
	}

    newMatch(teamData, token) {    
        //var respuesta = fetch('http://192.168.1.27/public/laraveldocker/public/api/partidos', {
        var respuesta = fetch(process.env.REACT_APP_URL+'partidos', {
            method: 'POST',
            // mode: 'cors',
            headers: {
                'Accept': 'application/json',
                'Authorization': 'Bearer '+token,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(teamData)
        })
        .then(data => data.json());
        console.log (respuesta);
        return respuesta;
    }

    ingresarResultadosPartido(teamData, token) {    
        //var respuesta = fetch('http://192.168.1.27/public/laraveldocker/public/api/ingresarResultadosPartido', {
        var respuesta = fetch(process.env.REACT_APP_URL+'ingresarResultadosPartido', {
            method: 'POST',
            // mode: 'cors',
            headers: {
                'Accept': 'application/json',
                'Authorization': 'Bearer '+token,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(teamData)
        })
        .then(data => data.json());
        return respuesta;
    }
}